import "./tabs.css";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const SelectStoreTab = ({ updateSelectedStore, resetFilter, disableStoreFilter }) => {
  const [show, setShow] = useState(false);
  const [selectedStore, setSelectedStore] = useState({
    storeName: "All stores",
    storeId: "1",
  });
  const { user } = useSelector((state) => state.webStoreUser);

  useEffect(() => {
    updateSelectedStore(selectedStore);
  }, [selectedStore]);

  useEffect(() => {
    console.log("resetting filter");
    setSelectedStore({ storeName: "All stores", storeId: "1" });
  }, [resetFilter]);

  return (
    <>
      <div className='storeTabselect353'>
        <div style={{ opacity: disableStoreFilter ? "0.7" : "1" }} onClick={() => (show ? setShow(false) : disableStoreFilter === false && setShow(true))}>
          <p>{selectedStore.storeName}</p>
          {show ? <IoMdArrowDropup size={30} /> : <IoMdArrowDropdown size={30} />}
        </div>
        {show && (
          <div className='dropdownstoresel'>
            <p
              onClick={() => {
                setSelectedStore({ storeName: "All stores", storeId: "1" });
                setShow(false);
              }}
            >
              {/* <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_mNmpqHOTakNgIaKR5bxJFfkUtiLdPBXPMw&usqp=CAU' alt='profileImage' /> */}
              <div>A</div>
              All store
            </p>
            {user.store.map((store, i) => (
              <p
                key={i}
                onClick={() => {
                  setSelectedStore({ storeName: store.storeName, storeId: store._id });
                  setShow(false);
                }}
              >
                <img src={store.storeImage} /> {store.storeName}
              </p>
            ))}

            {/*   <p
              onClick={() => {
                setSelectedStore("Freshmart jdu wjnis");
                setShow(false);
              }}
            >
              <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_mNmpqHOTakNgIaKR5bxJFfkUtiLdPBXPMw&usqp=CAU' alt='profileImage' /> Freshmart{" "}
            </p> */}
          </div>
        )}
      </div>
    </>
  );
};

export default SelectStoreTab;
